import Vue from 'vue'
// Vue.filter('price', function (value) {
//   // if (!value) return ''
//   return (Number(value) / 100).toFixed(2)
// })
// Vue.filter('currency', (value, currency = '￥', decimals = 2) => {
//   if(value){
//     return value.toLocaleString()
//   }else{
//     return 0;
//   }
// }
const digitsRE = /(\d{3})(?=\d)/g
Vue.filter('price', function (value, currency = '¥', decimals = 2) {
  // console.log('filter', value)
  value = parseFloat(value) / 100
  if (!isFinite(value) || (!value && value !== 0)) return ''
  var stringified = Math.abs(value).toFixed(decimals)
  var _int = decimals
    ? stringified.slice(0, -1 - decimals)
    : stringified
  var i = _int.length % 3
  var head = i > 0
    ? (_int.slice(0, i) + (_int.length > 3 ? ',' : ''))
    : ''
  var _float = decimals
    ? stringified.slice(-1 - decimals)
    : ''
  var sign = value < 0 ? '-' : ''
  return sign + currency + head +
    _int.slice(i).replace(digitsRE, '$1,') +
    _float
})
Vue.filter('telephone', function (value) {
  if (!value) {
    return false
  }
  return value.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
})




// WEBPACK FOOTER //
// ./src/filter/index.js